export default "__VITE_ASSET__7ca2c6de__"